"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageTypes = void 0;
var ImageTypes;
(function (ImageTypes) {
    ImageTypes["FRAME"] = "frame";
    ImageTypes["CLICK"] = "click";
})(ImageTypes = exports.ImageTypes || (exports.ImageTypes = {}));
//# sourceMappingURL=ImageProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Image/ImageProps.js
// module id = 1154
// module chunks = 8